import React, { useState } from "react";
import styles from './index.module.scss'
import { useNavigate } from "react-router";
import HeaderNav from "./compoments/headerNav";
import Invite from "./compoments/invite";
import DepositBonus from "./compoments/depositBonus";
import DailyCashRewards from "./compoments/dailyCashRewards";
import { useBaseConfig, useGetPageActivityBetTaskTotal, useInvitePrizeConfig, useInvitePrizeInfo } from "./hooks/useInviteFriends";
import LoadingUI from "@/compoments/loadingUI";
import { useTranslation } from "react-i18next";
import Icon from "@/wmCompoments/Icon";

const InviteFriends = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('inviteFriends')
  const [currentPage, setCurrentPage] = useState(0)
  // 邀请都有奖－邀请人数及奖励查询
  const { invitePrizeData, isLoading: InviteLoading} =useInvitePrizeInfo() || {}
  // 邀请都有奖/存款大福利/现金天天赚－分享图/活动说明，规则查询
  const { baseConfigData, isLoading: baseLoading } = useBaseConfig() || {}
  // 邀请都有奖－奖励配置信息查询
  const { prizeConfigData } = useInvitePrizeConfig() || {}
  // 现金天天赚-返利总计查询
  const {activityBetTaskData} = useGetPageActivityBetTaskTotal() || {}
  
  return (
    <div className={styles.inviteFriends}>
      <LoadingUI loading={InviteLoading || baseLoading} data={invitePrizeData || baseConfigData} height={700}>
      <div className={styles.title}>
        <div>{t('inviteFriend')}</div>
        <Icon name='icon-general-close' 
          onClick={() => navigate(-1)}
          className={styles.close}
        />
      </div>

      <HeaderNav activeIndex={currentPage} onButtonClick={setCurrentPage} />
      {currentPage === 0 && <Invite currentIndex={currentPage} invitePrizeData={invitePrizeData} baseConfigData={baseConfigData} prizeConfigData={prizeConfigData} />}
      {currentPage === 1 && <DepositBonus currentIndex={currentPage} />}
      {currentPage === 2 && <DailyCashRewards currentIndex={currentPage} baseConfigData={baseConfigData} activityBetTaskData={activityBetTaskData} />}
      </LoadingUI>
    </div>
  )
}

export default InviteFriends